var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4432",
    "data-name": "Group 4432",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.838,
    height: 27.838,
    viewBox: "0 0 27.838 27.838",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 13.919,
    cy: 13.919,
    r: 13.919,
    transform: "translate(0 0)",
    fill: "#0a64f9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3593",
    "data-name": "Path 3593",
    d: "M14.971,11.713a8.053,8.053,0,0,1-2.484-.394.688.688,0,0,0-.711.169l-1.1,1.386A10.686,10.686,0,0,1,5.822,8.067L7.195,6.9a.718.718,0,0,0,.169-.718A7.849,7.849,0,0,1,6.969,3.7a.7.7,0,0,0-.7-.7H3.837C3.457,3,3,3.169,3,3.7A12.071,12.071,0,0,0,14.971,15.668a.738.738,0,0,0,.7-.83V12.409A.7.7,0,0,0,14.971,11.713Z",
    transform: "translate(4.709 5.086)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone1);
export default __webpack_public_path__ + "static/media/Phone1.d722b81370e1c5d1925a02200aed5723.svg";
export { ForwardRef as ReactComponent };